// extracted by mini-css-extract-plugin
export default {"title":"burger-ingredients-list_title__tTIUk text_type_main-medium mb-6","list":"burger-ingredients-list_list__PJx2M pl-4 pr-2"};